type WalletType = 'basic' | 'credit' | 'loan' | 'other';

interface WalletCreatedData {
  type: WalletType;
  walletId: string;
}

type WalletEventMap = {
  'wallet:type-selected': WalletType;
  'wallet:created': WalletCreatedData;
  'wallet:create-error': { type: WalletType; error: string };
};

type EventCallback<T> = (data: T) => void;

class EventEmitter {
  private static instance: EventEmitter;
  private listeners: Map<keyof WalletEventMap, Set<EventCallback<any>>>;

  private constructor() {
    this.listeners = new Map();
  }

  static getInstance(): EventEmitter {
    if (!EventEmitter.instance) {
      EventEmitter.instance = new EventEmitter();
    }
    return EventEmitter.instance;
  }

  subscribe<K extends keyof WalletEventMap>(
    event: K,
    callback: EventCallback<WalletEventMap[K]>
  ): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(callback);

    // Return unsubscribe function
    return () => {
      const callbacks = this.listeners.get(event);
      if (callbacks) {
        callbacks.delete(callback);
      }
    };
  }

  publish<K extends keyof WalletEventMap>(
    event: K,
    data: WalletEventMap[K]
  ): void {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach(callback => callback(data));
    }
  }
}

export const walletEvents = EventEmitter.getInstance();
export type { WalletType, WalletCreatedData }; 